<template>
    <v-stepper>
        <v-stepper-header>
            <v-stepper-step step="1" :complete="currentStep >= 1"  :editable="currentStep == 1" @click="go('/')">
                
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="2" :complete="currentStep >= 2" :editable="currentStep == 2" @click="go('/date')">
                
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3" :complete="currentStep >= 3" :editable="currentStep == 3" @click="go('/confirm')">
                
            </v-stepper-step>
        </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
    name: 'steps',
    props:{
        currentStep: Number
    },
    data: () => ({
    }),
    methods:{
        go: function(path){
            this.$router.push(path);
        }
    }
}
</script>

<style>

.v-stepper{
    box-shadow:unset;
}

.v-stepper__header{
    box-shadow:unset;
}
</style>